const initialState = {
  edit: true,
  layout: {}
};

export default (state = initialState, action) => {
  let newState = state;
  switch (action.type) {
    case "TOGGLE_EDIT":
      newState = {
        ...state,
        edit: !state.edit
      };
      break;
    case "LAYOUT_CHANGE":
      newState = {
        ...state,
        layout: action.payload
      };
      break;
    default:
      break;
  }

  return newState;
};
